import { Box, Image, Text } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Close } from '../Icons/Close';
import Bicester from '../assets/images/bicester_stamp.png';
import Fidenza from '../assets/images/fidenza_stamp.png';
import LaRoca from '../assets/images/laroca_stamp.png';
import LaVallee from '../assets/images/lavallee_stamp.png';
import PassportLogo from '../components/PassportLogo';
import { CommonVillageNameProps } from '../interfaces/components';

const key = 'LaRocaStamps';
const laValleeKey = 'LaValleStamps';
const bicesterKey = 'BicesterStamps';
const fidenzaKey = 'FidenzaStamps';

const Passport = ({ active, setActive, villageName }: CommonVillageNameProps) => {
  const { t } = useTranslation();
  const [laRocaCollected, setLaRocaCollected] = useState<number>(0);
  const [laValleeCollected, setLaValleeCollected] = useState<number>(0);
  const [bicesterCollected, setBicesterCollected] = useState<number>(0);
  const [fidenzaCollected, setFidenzaCollected] = useState<number>(0);
  const [totalCollected, setTotalCollected] = useState<number>(0);

  useEffect(() => {
    if (active) {
      let total = 0;
      const value = localStorage.getItem(key);
      if (value && value !== null) {
        const parsedValue = JSON.parse(value);
        setLaRocaCollected(parsedValue.length);
        total += parsedValue.length;
      } else {
        setLaRocaCollected(0);
      }

      const lvValue = localStorage.getItem(laValleeKey);
      if (lvValue && lvValue !== null) {
        const parsedValue = JSON.parse(lvValue);
        setLaValleeCollected(parsedValue.length);
        total += parsedValue.length;
      } else {
        setLaValleeCollected(0);
      }

      const bvValue = localStorage.getItem(bicesterKey);
      if (bvValue && bvValue !== null) {
        const parsedValue = JSON.parse(bvValue);
        setBicesterCollected(parsedValue.length);
        total += parsedValue.length;
      } else {
        setBicesterCollected(0);
      }

      const fvValue = localStorage.getItem(fidenzaKey);
      if (fvValue && fvValue !== null) {
        const parsedValue = JSON.parse(fvValue);
        setFidenzaCollected(parsedValue.length);
        total += parsedValue.length;
      } else {
        setFidenzaCollected(0);
      }

      setTotalCollected(total);
      // console.log('Total Items Clicked', total);
    }
  }, [active]);

  const onCollectReward = () => {
    setActive();
    window.openGameReward();
  };

  return (
    <>
      <Box
        position="fixed"
        w="100%"
        h="100%"
        top="0"
        left="0"
        opacity={active ? 1 : 0}
        visibility={active ? 'visible' : 'hidden'}
        backgroundColor="rgba(0,0,0,0.2)"
        transition="all 1s"
        zIndex={4}
        onClick={() => setActive()}
      />
      <Box
        zIndex={10}
        opacity={active ? 1 : 0}
        visibility={active ? 'visible' : 'hidden'}
        transition="all 0.5s"
        position="fixed"
        top="auto"
        left="auto"
        bottom={['120px', '120px', '90px']}
        right={['15px', '15px', '25px']}
        margin="auto"
        backgroundColor="rgba(255, 255, 255, 1);"
        padding={['25px', '25px', '40px 25px', '40px 25px']}
        width={['300px', '300px', '300px', '300px', '300px']}
        // height={['450px', '450px', '480px', '480px', '480px']}
        h="max-content"
        border="1px solid lightgrey"
      >
        <Close
          boxSize={[6, 6, 7]}
          position="absolute"
          top={['25px', '25px', '25px']}
          right={['25px', '25px', '25px']}
          cursor="pointer"
          onClick={() => setActive()}
          zIndex={30}
        />
        <Text
          fontWeight="400"
          fontFamily="SangBleuBPLight"
          fontSize={['16px', '16px', '18px', '20px', '20px']}
          width="100%"
          color="#455255"
          textAlign="center"
        >
          {t('passport-title')}
        </Text>
        <Box display="flex" flexFlow="row" flexWrap="wrap" gap="8" w="200px" mx="auto" my="7" justifyContent="center">
          <PassportLogo
            logo={LaRoca}
            name="La Roca Village"
            fill="#FFD41F"
            stroke="#FFD93B"
            collected={laRocaCollected}
          />
          <PassportLogo
            logo={Bicester}
            name="Bicester Village"
            fill="#A60B2B"
            stroke="#A60B2B"
            collected={bicesterCollected}
          />
          <PassportLogo
            logo={Fidenza}
            name="Fidenza Village"
            fill="#80AA9F"
            stroke="#80AA9F"
            collected={fidenzaCollected}
          />
          <PassportLogo
            logo={LaVallee}
            name="La Vallée"
            fill="#664D86"
            stroke="#664D86"
            collected={laValleeCollected}
          />
        </Box>

        <Box display="flex" justifyContent="center">
          {totalCollected >= 12 ? (
            <Box
              w="230px"
              border="1px solid #C29F6B"
              display="flex"
              flexDir="row"
              justifyContent="center"
              alignItems="center"
              gap="1"
              bg="white"
              px="3"
              mt="3"
              py="3"
              onClick={onCollectReward}
              cursor="pointer"
            >
              <Text
                fontWeight="500"
                fontSize={['12px', '12px', '14px', '16px', '16px']}
                lineHeight={['16px', '16px', '18px', '20px', '20px']}
                color="#C29F6B"
                fontFamily="JosefinSans"
                textAlign="center"
                maxW="80%"
              >
                {t('passport-collect-reward')}
              </Text>
            </Box>
          ) : laRocaCollected >= 3 || laValleeCollected >= 3 || bicesterCollected >= 3 || fidenzaCollected >= 3 ? (
            <Box
              w="230px"
              border="1px solid #C29F6B"
              display="flex"
              flexDir="row"
              justifyContent="center"
              alignItems="center"
              gap="1"
              bg="white"
              px="3"
              mt="3"
              py="3"
            >
              <Image
                src={
                  villageName === 'la_vallee'
                    ? LaVallee
                    : villageName === 'bicester'
                    ? Bicester
                    : villageName === 'fidenza'
                    ? Fidenza
                    : LaRoca
                }
                w="35px"
                h="35px"
                objectFit="contain"
                alt="stamp"
              />
              <Text
                fontWeight="500"
                fontSize={['12px', '12px', '14px', '16px', '16px']}
                lineHeight={['16px', '16px', '18px', '20px', '20px']}
                color="#C29F6B"
                fontFamily="JosefinSans"
                textAlign="center"
                maxW="80%"
              >
                {t('passport-stamp-earned')}
              </Text>
            </Box>
          ) : (
            <Box
              w="265px"
              // h={['90px', '90px', '100px']}
              border="1px solid #C29F6B"
              display="flex"
              flexDir="column"
              justifyContent="center"
              alignItems="center"
              gap="1"
              bg="white"
              py="3"
            >
              <Text
                fontWeight="500"
                fontSize={['12px', '12px', '14px', '16px', '16px']}
                lineHeight={['16px', '16px', '18px', '20px', '20px']}
                color="#C29F6B"
                fontFamily="JosefinSans"
                textAlign="center"
                maxW="80%"
              >
                {t('passport-nothing-yet')}
              </Text>
              <Text
                fontWeight="500"
                fontSize={['12px', '12px', '14px', '16px', '16px']}
                lineHeight={['16px', '16px', '18px', '20px', '20px']}
                color="#C29F6B"
                fontFamily="JosefinSans"
                textAlign="center"
                maxW="80%"
              >
                {t('passport-info')}
              </Text>
            </Box>
          )}
        </Box>
      </Box>
    </>
  );
};
export default Passport;
